import templateIds from '../../../constants/templates.constants';
import { TLinkField, TStringField } from '../../../types/sitecore.types';
import { InteractiveImageFields, InteractiveImageMblDeskItemField, InteractiveImageProps } from '../types/interactiveImage.types';

export class InteractiveImageModel {
  private readonly fields: InteractiveImageFields | undefined;
  private readonly params: IComponentParamsGeneral | undefined;

  constructor(props: InteractiveImageProps) {
    this.fields = props?.fields || {};
    this.params = props?.params;
  }

  get eyebrow(): TStringField | undefined {
    return this.fields?.optionalEyebrow;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get description(): TStringField | undefined {
    return this.fields?.description;
  }

  get primaryLink(): TLinkField | undefined {
    return this.fields?.hotspotLink;
  }

  mblDeskItem(isWide: boolean): InteractiveImageMblDeskItemField {
    const templateIdOfField = isWide ? templateIds['interactiveImage']['dskHotspotId'] : templateIds['interactiveImage']['mblHotspotId'];
    return this.fields?.items?.find((_) => _.fields?.templateId === templateIdOfField)?.fields || {};
  }
}
